<template>
  <div class="card-item-box" :class="css">
    <div class="card-item">
      <slot name="card-header">
        <div class="card-header">
          <div class="card-h-icon">
            <slot name="card-icon">
              <u-icon :name="icon" :type="iconType" :icon-style="iconStyle || 'solid'"/>
            </slot>
          </div>
          <div class="card-h-content">{{ legend }}</div>
          <div class="card-h-actions">
            <u-btn icon="ellipsis-v" icon-type="fa" size="sm" flat round/>
          </div>
        </div>
      </slot>
      <slot name="card-body">
        <div v-if="!loading" class="card-body">
          <slot/>
        </div>
        <div v-else class="card-body">
          <div class="wrapper">
            <u-fake-loader width="90%" />
            <u-fake-loader width="40%" />
            <u-fake-loader width="24%" />
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import {UFakeLoader} from 'uloc-vue'
export default {
  name: "CardItem",
  components: {UFakeLoader},
  props: {
    'icon': {required: false},
    'iconType': {required: false},
    'iconStyle': {required: false},
    'legend': {required: false},
    alertBorder: {
      required: false,
      type: String
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    css() {
      let css = []
      if (this.alertBorder) {
        css.push('border-' + this.alertBorder)
      }
      if (this.loading) {
        css.push('is-loading')
      }
      return css
    }
  }
}
</script>
